/**
 * Contact — `/contact` route.
 *
 * Body is now the hand-built design from `contact_1.html` (rendered
 * verbatim via the `ContactHero` component / shared `PageHost` wrapper).
 *
 * Navbar and Footer are unchanged: this page keeps importing and
 * rendering the existing site Navbar and Footer per the user's rule.
 *
 * URL search-param prefill (`?inquiry=builder|institution|...`) is
 * handled inside the page script — see `landing/contact/script.js`.
 *
 * Form submits to `POST /api/contact` (same-origin fetch). The backend
 * route lives in `/app/backend/routers/contact.py` and accepts the same
 * payload shape the form sends.
 */
import { Helmet } from "react-helmet-async";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { ContactHero } from "../components/ContactHero";

export default function Contact() {
  return (
    <main className="min-h-screen bg-aubergine" data-testid="contact-page">
      <Helmet>
        <title>Contact · T-REX Network</title>
        <meta
          name="description"
          content="Talk to the T-REX Network team. Institutional tokenisation, builder grants, partnerships, and media inquiries."
        />
      </Helmet>
      <Navbar />
      {/* Spacer to clear the fixed Navbar so the hero begins below it. */}
      <div aria-hidden="true" style={{ height: 64 }} />
      <ContactHero />
      <Footer />
    </main>
  );
}
